import { createFetcher } from '../contexts/Fetcher';
import { apiLicense } from '../resources/api/apiLicense';
import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { pending } from '../helpers/pending';

const { useGetUserLicenses } = apiLicense;

export const UserLicensesFetcher = createFetcher(() => {
  const { userId } = useContext(UserContext);
  const { organization } = useContext(OrganizationContext);

  const { execute } = useGetUserLicenses(organization ?? void 0, userId ?? void 0);
  return organization && userId ? execute : pending;
});
